import { render, staticRenderFns } from "./Fideicomiso.vue?vue&type=template&id=8cada312"
import script from "./Fideicomiso.vue?vue&type=script&lang=js"
export * from "./Fideicomiso.vue?vue&type=script&lang=js"
import style0 from "./Fideicomiso.vue?vue&type=style&index=0&id=8cada312&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports